import React, { useEffect, useState } from 'react';

const ItemFields = [
    { key: 'surveyID', label: 'Survey ID', type: 'text' },
    { key: 'requestDate', label: 'Request Date', type: 'date' },
    { key: 'siteName', label: 'Site', type: 'text' },
    { key: 'deviceID', label: 'Device ID', type: 'text' },
    { key: 'contact', label: 'Contact', type: 'text' },
    { key: 'phoneNumber', label: 'Phone Number', type: 'text' },
    { key: 'scheduledDate', label: 'Scheduled Date', type: 'date' },
    { key: 'assignedTo', label: 'Assigned To', type: 'text' },
    { key: 'surveyDate', label: 'Survey Date', type: 'date' },
    { key: 'dispatchNumber', label: 'Dispatch Number', type: 'text' },
    { key: 'inspectedBy', label: 'Inspected By', type: 'text' },
    { key: 'surveyType', label: 'Survey Type', type: 'text' }
];
const SurveyRequestEntry = () => {
    const tableHeaders = ["Survey ID", "Request Date", "Site", "Device ID", "Contact", "Phone Number", "Scheduled Date", "Assigned To", "Edit"];
    const [surveyEntryData, setSurveyEntryData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({});
    const [lookupSurveyId, setLookupSurveyId] = useState('');
    const [isEditing, setIsEditing] = useState(false); // State to track editing

    const fetchEntries = async () => {
        try {
            const response = await fetch('http://localhost:8080/api/callcenter/survey-request-entry');
            const data = await response.json();
            setSurveyEntryData(data);
            console.log(data);
        } catch (error) {
            console.error('Error fetching survey requests:', error);
        }
    }

    useEffect(() => {
        fetchEntries();
    }, []);

    const formatDateTimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const addItem = async () => {
        try {
            const response = await fetch('http://localhost:8080/api/callcenter/survey-request-entry/addSurveyRequestEntry', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (!response.ok) {
                throw new Error("Failed to add item");
            }
            alert("Add Successful");
            toggleModal();
            fetchEntries();
        } catch (error) {
            console.error("Submit Error: ", error);
        }
    };

    const editItem = async () => {
        try {
            const response = await fetch(`http://localhost:8080/api/callcenter/survey-request-entry/${lookupSurveyId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (!response.ok) {
                throw new Error("Failed to edit item");
            }
            alert("Update Successful");
            toggleModal();
            fetchEntries();
        } catch (error) {
            alert("Edit Failed (Make sure the item number is correct in lookup)")
            console.error("Edit Error: ", error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isEditing) {
            editItem();
        } else {
            addItem();
        }
    };

    const handleDelete = async () => {
        try {
            console.log(lookupSurveyId);

            const response = await fetch(`http://localhost:8080/api/callcenter/survey-request-entry/${formData.surveyID}`, {
                method: 'DELETE',
            });
            if (!response.ok) {
                throw new Error("Failed to delete item");
            }
            fetchEntries();
            toggleModal();
        } catch (error) {
            alert("Item Number Not Found!!")
            console.error("Lookup Error: ", error);
        }
    }

    const handleLookup = async () => {
        try {
            console.log(lookupSurveyId);

            const response = await fetch(`http://localhost:8080/api/callcenter/survey-request-entry/${lookupSurveyId}`);
            if (!response.ok) {
                throw new Error("Item not found");
            }
            const data = await response.json();
            const formattedData = {
                ...data,
                created: data.created ? formatDateTimeLocal(data.created) : '',
                scheduled: data.scheduled ? formatDateTimeLocal(data.scheduled) : '',
            };
            setFormData(formattedData);
        } catch (error) {
            alert("Item Number Not Found!!")
            console.error("Lookup Error: ", error);
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name);
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const openFormForEdit = (item) => {
        setFormData({
            ...item,
            created: item.created ? formatDateTimeLocal(item.created) : '',
            scheduled: item.scheduled ? formatDateTimeLocal(item.scheduled) : '',
        });


        setLookupSurveyId(item.surveyID);
        setIsEditing(true);
        toggleModal();
    };

    const openFormForAdd = () => {
        setFormData({});
        setIsEditing(false);
        toggleModal();
    };


    return (
        <div className="mx-auto h-screen w-full">
            <div className="flex justify-between items-center p-3 mb-4">
                <div className="flex justify-start items-center">
                    <h2 className="mr-10 text-2xl font-bold">Survey Request Entry</h2>
                </div>
                <div className="flex space-x-1 items-center">
                    <button
                        className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 flex text-sss-blue-sel font-bold
                        hover:bg-yellow-500 transition duration-300 ease-in-out"
                        onClick={() => openFormForAdd()}
                    >
                        Add +
                    </button>
                </div>
            </div>
            <div className="overflow-x-auto overflow-y-auto p-5 flex items-center">
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            {tableHeaders.map((field) => (
                                <th key={field} className="px-4 py-2 text-left font-semibold text-gray-600">
                                    {field}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {surveyEntryData.map((entry, index) => (
                            <tr key={index} className="border-t hover:bg-sss-accent-yel">
                                <td className="px-4 py-2">{entry.surveyID}</td>
                                <td className="px-4 py-2">{entry.requestDate}</td>
                                <td className="px-4 py-2">{entry.siteName}</td>
                                <td className="px-4 py-2">{entry.deviceID}</td>
                                <td className="px-4 py-2">{entry.contact}</td>
                                <td className="px-4 py-2">{entry.phoneNumber}</td>
                                <td className="px-4 py-2">{entry.scheduledDate}</td>
                                <td className="px-4 py-2">{entry.assignedTo}</td>
                                <td className="px-4 py-2">
                                    <button
                                        className="text-blue-500 py-2 px-4 rounded"
                                        onClick={() => openFormForEdit(entry)}
                                    >
                                        Edit
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="fixed inset-0 bg-black opacity-50"></div>
                    <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-h-screen overflow-y-auto">
                        <h2 className="text-2xl font-bold mb-4">{isEditing ? 'Edit Item' : 'Add Item'}</h2>
                        <div className='space-y-4'>
                            <form onSubmit={handleSubmit}>
                                <div className="grid grid-cols-2 gap-4">
                                    {ItemFields.map((field) => (
                                        <div key={field.key} className="mb-4">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={field.key}>
                                                {field.label}
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                id={field.key}
                                                name={field.key}
                                                type={field.type}
                                                value={formData[field.key] || ''}
                                                onChange={handleChange}
                                                disabled={isEditing && field.key === 'surveyID'}
                                                required
                                            />
                                        </div>
                                    ))}
                                </div>
                                {isEditing && (
                                    <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="lookupItemNumber">
                                            Lookup Survey ID
                                        </label>
                                        <div className="flex">
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                id="lookupSurveyId"
                                                type="text"
                                                placeholder="Enter Item Number to Lookup"
                                                value={lookupSurveyId}
                                                onChange={(e) => setLookupSurveyId(e.target.value)}
                                            />
                                            <button
                                                type="button"
                                                className="ml-2 bg-sss-accent-yel text-sss-blue-sel font-bold py-2 px-4 rounded hover:bg-yellow-500 transition duration-300 ease-in-out"
                                                onClick={handleLookup}
                                            >
                                                Lookup
                                            </button>
                                        </div>
                                    </div>
                                )}
                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        className="bg-sss-accent-yel text-sss-blue-sel font-bold py-2 px-4 rounded hover:bg-yellow-500 transition duration-300 ease-in-out"
                                    >
                                        {isEditing ? 'Update' : 'Add'}
                                    </button>
                                    <button
                                        type="button"
                                        className="ml-2 bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded hover:bg-gray-400 transition duration-300 ease-in-out"
                                        onClick={toggleModal}
                                    >
                                        Close
                                    </button>
                                    {isEditing && (
                                        <button
                                            type="button"
                                            className="ml-2 border border-red-500 bg-red-500 rounded px-5 py-2 text-white font-bold
                        hover:bg-red-700 transition duration-300 ease-in-out"
                                            onClick={handleDelete}
                                        >
                                            Delete
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SurveyRequestEntry;
